
import Select from './Select';
import SelectMultiple from './SelectMultiple';
import Option from './Option';

Select.Multiple = SelectMultiple;
Select.Option = Option;

export default Select;
